import Permissions from 'src/security/permissions';
import { i18n } from 'src/i18n';

import {
  DashboardOutlined,
  UserAddOutlined,
  SettingOutlined,
  UserOutlined,
  CreditCardOutlined,
  BookOutlined,
  SnippetsOutlined,
  ShopOutlined,
  ProfileOutlined,
  FileImageOutlined,
  HeartOutlined,
  DeploymentUnitOutlined,
  RestOutlined,
  SolutionOutlined,
  CrownOutlined,
  UsergroupAddOutlined,
  OrderedListOutlined,
  BarcodeOutlined,
  QrcodeOutlined,
  ToolOutlined,
  WarningOutlined,
  CloudUploadOutlined,
  AppstoreOutlined,
  BellOutlined,
  AreaChartOutlined,
} from '@ant-design/icons';

const permissions = Permissions.values;

export const secondaryMenu = [
  {
    path: '/admin-panel/users',
    parentPath: '/admin-panel/:page',
    permissionRequired: permissions.superAdmin,
    icon: <CrownOutlined />,
    label: 'Admin Panel',
  },
  {
    path: '/profile',
    icon: <UserOutlined />,
    label: i18n('auth.profile.title'),
    permissionRequired: permissions.settingsEdit,
  },
  {
    path: '/settings',
    icon: <SettingOutlined />,
    label: i18n('settings.menu'),
    permissionRequired: permissions.settingsEdit,
  },

  {
    path: '/plan',
    permissionRequired: permissions.planRead,
    icon: <CreditCardOutlined />,
    label: i18n('plan.menu'),
  },
  {
    path: '/tenant',
    permissionRequired: permissions.tenantEdit,
    icon: <ShopOutlined />,
    label: i18n('tenant.menu'),
  },
  {
    path: '/user',
    label: i18n('user.menu'),
    permissionRequired: permissions.userRead,
    icon: <UserAddOutlined />,
  },
];

export const mainMenu = [
  {
    path: '/',
    exact: true,
    icon: <DashboardOutlined />,
    label: i18n('dashboard.menu'),
    permissionRequired: null,
  },

  {
    path: '/e-label',
    permissionRequired: permissions.eLabelRead,
    icon: <BookOutlined />,
    label: i18n('entities.eLabel.menu'),
  },

  {
    path: '/catalog',
    permissionRequired: permissions.catalogRead,
    icon: <AppstoreOutlined />,
    label: i18n('entities.catalog.menu'),
    isNew: true,
  },

  {
    path: '/analytics',
    parentPath: '/analytics/*',
    permissionRequired: permissions.analyticsRead,
    icon: <AreaChartOutlined />,
    label: i18n('entities.analytics.menu'),
    isNew: true,
  },

  {
    path: '/library/nutrition-information',
    parentPath: '/library/:page',
    permissionRequired: permissions.producerRead,
    icon: <SnippetsOutlined />,
    label: i18n('library.menu'),
  },

  {
    path: '/tools/barcode',
    parentPath: '/tools/:page',
    permissionRequired: permissions.producerRead,
    icon: <ToolOutlined />,
    label: i18n('tools.title'),
  },
].filter(Boolean);

export const libraryMenu = [
  {
    path: '/library/nutrition-information',
    permissionRequired: permissions.nutritionInformationRead,
    label: i18n('entities.nutritionInformation.menu'),
    icon: <ProfileOutlined />,
  },

  {
    path: '/library/image',
    permissionRequired: permissions.imageRead,
    label: i18n('entities.image.menu'),
    icon: <FileImageOutlined />,
  },

  {
    path: '/library/ingredients',
    permissionRequired: permissions.nutritionInformationRead,
    label: i18n('entities.ingredients.menu'),
    icon: <OrderedListOutlined />,
  },

  {
    path: '/library/sustainability',
    permissionRequired: permissions.sustainabilityRead,
    label: i18n('entities.sustainability.menu'),
    icon: <HeartOutlined />,
  },

  {
    path: '/library/packaging-certification',
    permissionRequired: permissions.packagingCertificationRead,
    label: i18n('entities.packagingCertification.menu'),
    icon: <RestOutlined />,
  },

  {
    path: '/library/recycling-materials',
    permissionRequired: permissions.recyclingMaterialsRead,
    label: i18n('entities.recyclingMaterials.menu'),
    icon: <DeploymentUnitOutlined />,
  },

  {
    path: '/library/responsible-consumption',
    permissionRequired: permissions.responsibleConsumptionRead,
    label: i18n('entities.responsibleConsumption.menu'),
    icon: <WarningOutlined />,
  },

  {
    path: '/library/food-operator',
    permissionRequired: permissions.foodOperatorRead,
    label: i18n('entities.foodOperator.menu'),
    icon: <SolutionOutlined />,
  },
].filter(Boolean);

export const toolsMenu = [
  {
    path: '/tools/barcode',
    permissionRequired: permissions.imageRead,
    label: i18n('tools.menu.barCode'),
    icon: <BarcodeOutlined />,
  },

  {
    path: '/tools/qrcode',
    permissionRequired: permissions.imageRead,
    label: i18n('tools.menu.qrCode'),
    icon: <QrcodeOutlined />,
  },
].filter(Boolean);

export const adminMenu = [
  {
    path: '/admin-panel/users',
    permissionRequired: permissions.superAdmin,
    label: 'Users',
    icon: <UsergroupAddOutlined />,
  },

  {
    path: '/admin-panel/default-images',
    permissionRequired: permissions.superAdmin,
    label: 'Default Images',
    icon: <FileImageOutlined />,
  },
  {
    path: '/admin-panel/create-contract',
    permissionRequired: permissions.superAdmin,
    label: 'Create Contract',
    icon: <SnippetsOutlined />,
  },
  {
    path: '/admin-panel/upload-contacts/plunk',
    permissionRequired: permissions.superAdmin,
    label: 'Upload Contacts Plunk',
    icon: <CloudUploadOutlined />,
  },
  {
    path: '/admin-panel/notifications',
    permissionRequired: permissions.superAdmin,
    label: 'Notifications',
    icon: <BellOutlined />,
  },
].filter(Boolean);
